var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotificationSvgrepo = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-icon",
  style: {
    width: "2em",
    height: "2em",
    verticalAlign: "middle",
    fill: "#F8981F",
    overflow: "hidden"
  },
  viewBox: "0 0 1024 1024"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M894.31 918.58H137.83c-40.8 0-73.98-33.19-73.98-73.98V267.85c0-40.8 33.19-73.98 73.98-73.98h756.48c40.8 0 73.98 33.19 73.98 73.98V844.6c0.01 40.79-33.18 73.98-73.98 73.98z m-756.48-675.4c-13.6 0-24.66 11.07-24.66 24.66v576.75c0 13.6 11.06 24.66 24.66 24.66h756.48c13.6 0 24.66-11.07 24.66-24.66V267.85c0-13.6-11.06-24.66-24.66-24.66H137.83z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M307.58 96.01h49.32v239.65h-49.32zM675.23 96.01h49.32v239.65h-49.32z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M289.45 764.72l-38.11-200.01 191.29-39.94 256.9-155.82 81.25 372.21-300.37-31.39-190.96 54.95z m26.54-156.89l16.54 86.83 142.93-41.13 234.82 24.53-48.35-221.47-198.66 120.49-147.28 30.75z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M394.655 703.975l54.699-8.99 16.868 102.627-54.698 8.99z"
})));
export default __webpack_public_path__ + "static/media/notification-svgrepo.b52fd114.svg";
export { SvgNotificationSvgrepo as ReactComponent };